import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

@Injectable({
  providedIn: 'root'
})
export class OptionalHolidayService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { 
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  ESS_EmployeeOptionalHolidayLoadGet(Detail: any)   {
    return this.http.post<any>(environment.API_URL + `ESS_EmployeeOptionalHolidayLoad/Get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmployeeOptionalHolidaySave(Detail: any)   {
    return this.http.post<any>(environment.API_URL + `ESS_EmployeeOptionalHoliday/Save`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_OptionalHolidayRuleLoad(Detail: any)   {
    return this.http.post<any>(environment.API_URL + `ESS_OptionalHolidayRule/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_OptionalHolidayRuleInsertUpdate(Detail: any)   {
    return this.http.post<any>(environment.API_URL + `ESS_OptionalHolidayRuleInsert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmployeeOptionalHolidayWithdrawLoad(Detail: any)   {
    return this.http.post<any>(environment.API_URL + `ESS_EmployeeOptionalHolidayWithdraw/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
